<template>
	<div class="appendage-search-body">
		<div class="search-wrap">
			<div class="filters-box-row">
				<div class="filters-container">
					<div class="button-input" style="width: 300px;display: flex;align-items: center;margin-right: 20px;">
						<el-input
							style="flex: 1;"
							v-model="keyword"
							placeholder="搜索"
							size="small"
							maxlength="50"
							@keyup.enter.native="search">
						</el-input>
						<el-button icon="el-icon-search" size="mini" type="primary" @click='search'></el-button>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>门店：</span>
						<el-select placeholder="请选择门店" filterable @change="search" v-model="shopIds" multiple collapse-tags class="filter-input" size='small'>
							<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户：</span>
						<el-select
							class="filter-input cancel-select"
							size="small"
							v-model="customerIds"
							filterable
							@change="search"
							multiple
							collapse-tags
							style="margin-left: 20px;"
							placeholder="请选择客户">
							<el-option
								v-for="item in customerOptions"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>生效条件：</span>
						<el-select @change="search" v-model="type" class="filter-input cancel-select" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="0" label="订单足额"></el-option>
							<el-option :value="1" label="下单主商品"></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="search-right-box">
				<el-button plain size='mini' class="fx-btn" @click="clear">清空</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	data () {
		return {
			customerOptions: [],
			shopList: [],
			type: -1,
			keyword: '',
			customerIds: [],
			shopIds: []
		}
	},
	created () {
		this.getShopList()
		this.findCustomer()
	},
	methods: {
		search () {
			let params = {
				type: this.type,
				keyword: this.keyword,
				shopIds: this.shopIds,
				customerIds: this.customerIds
			}
			this.$emit('handleSearch', params)
		},
		clear () {
			this.type = -1
			this.keyword = ''
			this.customerIds = []
			this.shopIds = []
			this.search()
		},
		findCustomer () {
			let params = {
				name: '',
				customercategoryid: '-1'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfoForCondition`,
				data: params
			}).then(res => {
				this.customerOptions = res.data
			})
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.appendage-search-body {
	min-width: 1260px;
	.search-wrap {
		width: 100%;
		display: flex;
		.search-right-box {
			width: 120px;
			flex-shrink: 0;
			line-height: 50px
		}
	}
}
.filters-box-row {
	display: flex;
	align-items: center
	flex-wrap: wrap;
	// padding: 10px 0 0 0;
	// width :100%;
	line-height :50px;
	// min-width :600px;
	box-sizing: border-box
	text-align: left
	overflow: hidden
	.filters-container {
		.input-box{
			margin-right: 10px
			&>span {
				display: inline-block;
				// width: 130px;
				text-align: right
			}
		}
	}
}
</style>
<style lang="stylus">
	.button-input{
		input{
			border-top-right-radius :0px
			border-bottom-right-radius :0px
		}
		button{
			height: 32px;
			border-top-left-radius :0px;
			border-bottom-left-radius :0px
		}
	}
</style>
